/* eslint-disable no-underscore-dangle */
/* eslint-disable react/forbid-prop-types */
import { React, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Accordion, AccordionDetails, AccordionSummary, Box, Button, Paper, Typography,
} from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';
import MaterialTable from 'material-table';
import uiActions from '../../redux/actions/uiActions';
import ZoomLinks from '../Dashboard/components/ZoomLinks';
import companyServices from '../../redux/services/companyServices';
import { exportXlsx, Loading, numGradeToEUgrade } from '../../helpers/utils';
import teacherServices from '../../redux/services/teacherServices';

const Group = ({
  company,
  group,
  changePageTitle,
}) => {
  const [presentialGroups, setPresentialGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const getPresentialGroupsData = async () => {
    const companyRes = await companyServices.getCompany(company._id);
    if (companyRes.presentialGroups && companyRes.presentialGroups.length > 0) {
      const presentialGroupsArr = [];
      companyRes.presentialGroups.forEach((presentialGroup) => {
        if (presentialGroup.semester === group.semester) {
          presentialGroupsArr.push(presentialGroup);
        }
      });
      setPresentialGroups(presentialGroupsArr);
      setLoading(false);
    } else {
      setLoading(false);
    }
  };
  useEffect(() => {
    changePageTitle('Presential Group(s)');
  }, [changePageTitle]);

  useEffect(() => {
    getPresentialGroupsData();
  }, [company, group]);

  const handleExport = async (presentialGroup) => {
    // await Promise.all(presentialGroups.map(async (presentialGroup) => {
    const data = [];
    presentialGroup.students.forEach((student) => {
      data.push({ Nom: student.name, Prenom: student.firstname });
    });
    let teacher;
    if (presentialGroup.teacher[0]) {
      teacher = await teacherServices.getTeacherById(presentialGroup.teacher[0]);
    }
    data.push({ Nom: `Enseignant(e): ${teacher?.name || ''} ${teacher?.firstname || ''}` }, { Nom: `Lien zoom: ${presentialGroup.zoomLink || ''}` });
    exportXlsx(data, presentialGroup.name);
    // }));
  };

  const columns = [
    {
      title: 'Nom',
      field: 'name',
    },
    {
      title: 'Prénom',
      field: 'firstname',
    },
    {
      title: 'Niveau',
      field: 'level',
      render: ({ level }) => {
        if (level === null) return <Typography variant="body2">Pas de résultat</Typography>;
        return <Typography variant="body2">{numGradeToEUgrade(level)}</Typography>;
      },
    }, // demandé: field vide
  ];

  if (loading) return <Loading />;

  return (
    <div style={{ margin: '30px' }}>
      {presentialGroups.length > 0 ? (
        <Paper style={{ padding: 16 }}>
          {presentialGroups.map((presentialGroup) => {
            const hasSubgroups = Array.isArray(presentialGroup.subgroups)
              && presentialGroup.subgroups.length > 0;

            // Accordion simple si pas de subgroups
            if (!hasSubgroups) {
              return (
                <Accordion
                  key={presentialGroup._id || presentialGroup.id || presentialGroup.name}
                  disableGutters
                >
                  <AccordionSummary expandIcon={<ExpandMore />}>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        width: '100%',
                        gap: 12,
                      }}
                    >
                      <Typography fontWeight={600}>
                        {presentialGroup.name}
                      </Typography>

                      <Button
                        variant="contained"
                        color="primary"
                        disableElevation
                        onClick={(e) => {
                          e.stopPropagation();
                          handleExport(presentialGroup);
                        }}
                        onFocus={(e) => e.stopPropagation()}
                      >
                        Export
                      </Button>
                    </div>
                  </AccordionSummary>

                  <AccordionDetails>
                    <MaterialTable
                      title={presentialGroup.name}
                      columns={columns}
                      data={presentialGroup.students}
                      style={{
                        width: '100%',
                        maxWidth: '1000px',
                      }}
                      options={{
                        pageSize: 5,
                        pageSizeOptions: [5, 10, 20, 50, 100],
                        search: true,
                      }}
                    />
                  </AccordionDetails>
                </Accordion>
              );
            }

            // Si subgroups : accordion parent + accordions enfants
            return (
              <div>
                <Typography
                  variant="h6"
                  style={{
                    marginBottom: '30px',
                    marginTop: '30px',
                    backgroundColor: '#3E5EA7',
                    color: '#fff',
                    padding: '10px',
                    borderRadius: '5px',
                  }}
                >
                  {presentialGroup.name}
                </Typography>

                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    justifyItems: 'space-around',
                    flexWrap: 'wrap',
                    gap: '15px',
                  }}
                >
                  {presentialGroup.subgroups.map((subgroup) => {
                    if (subgroup.status) {
                      return (
                        <MaterialTable
                          style={{
                            width: '100%',
                            maxWidth: '550px',
                          }}
                          title={subgroup.name}
                          columns={columns}
                          data={subgroup.students}
                          options={{
                            pageSize: 5,
                            pageSizeOptions: [5, 10, 20, 50, 100],
                            search: true,
                            exportButton: {
                              csv: true,
                              pdf: false,
                            },
                            exportCsv: () => {
                              handleExport(subgroup);
                            },
                          }}
                        />
                      );
                    }
                    return <></>;
                  })}
                </Box>
              </div>
            );
          })}
        </Paper>
      ) : (
        <ZoomLinks group={group} company={company} />
      )}
    </div>
  );
};

Group.propTypes = {
  company: PropTypes.object.isRequired,
  group: PropTypes.object.isRequired,
  changePageTitle: PropTypes.func.isRequired,
};

function mapState(state) {
  const { data } = state.group;
  const { currentGroup } = state.ui;
  const { userData } = state.user;
  const { company } = userData;
  return {
    company, group: data[currentGroup],
  };
}

const actionCreators = {
  changePageTitle: uiActions.changePageTitle,
};

export default connect(mapState, actionCreators)(Group);
